import React from 'react';
import { Modal, Button, Badge, Row, Col } from 'react-bootstrap';

const ItemDescripcionModal = ({ show, onHide, item }) => {
    if (!item) return null;

    const estadoBadge = item.estado === 'Inactivo'
        ? <Badge bg="warning" text="dark">Inactivo</Badge>
        : <Badge bg="success">Activo</Badge>;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{item.nombre}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-2">
                    <Col xs={5} className="text-muted">Código</Col>
                    <Col>{item.codigo ?? '—'}</Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={5} className="text-muted">Magnitud</Col>
                    <Col>{item.magnitud?.nombre || '—'}</Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={5} className="text-muted">Grupo</Col>
                    <Col>{item.grupo || '—'}</Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={5} className="text-muted">Precio</Col>
                    <Col>${item.precio ?? 0}</Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={5} className="text-muted">Tiempo</Col>
                    <Col>{item.tiempo} min</Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={5} className="text-muted">Núm. patrones</Col>
                    <Col>{item.numPatrones ?? 1}</Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={5} className="text-muted">Estado</Col>
                    <Col>{estadoBadge}</Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={5} className="text-muted">Vinculación contable</Col>
                    <Col>
                        {item.contabilidad?.id
                            ? <><Badge bg="success">✅</Badge> {item.contabilidad.name}</>
                            : '—'}
                    </Col>
                </Row>
                <hr />
                <div className="text-muted small mb-1">Descripción</div>
                <p className="mb-0">{item.descripcion || 'Sin descripción registrada'}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ItemDescripcionModal;
